export const CONTAINER = 'CONTAINER';
export const CUSTOMER = 'CUSTOMER';
export const NOTE = 'COMMENT';
export const ORDER_NUMBER = 'ORDER_NUMBER';
export const CONTAINER_FILTER = 'name][like';
export const CUSTOMER_FILTER = 'projectArea][project][customer][name';
export const NOTE_FILTER = 'storagearea][storageNote';
export const ORDER_NUMBER_FILTER = 'projectArea][project][orderNumber';
